import { Accordion, Group, Paper, Text } from '@mantine/core'
import { ShiftTemplateNode } from 'modules/schedules/types.graphql'
import { ShiftTemplateAccordionItem } from './ShiftTemplateAccordionItem'
import { createStyles } from '@mantine/emotion'

interface ShiftTemplateAccordionProps {
  shiftTemplates: ShiftTemplateNode[]
}

export const ShiftTemplateAccordion: React.FC<ShiftTemplateAccordionProps> = ({
  shiftTemplates,
}) => {
  const { classes } = shiftTemplateAccordionStyles()
  const accordionItems = shiftTemplates.map(shiftTemplate => {
    return (
      <ShiftTemplateAccordionItem
        key={shiftTemplate.id}
        shiftTemplate={shiftTemplate}
      />
    )
  })
  return (
    <Paper>
      <Accordion multiple>
        <Accordion.Item value="header">
          <Accordion.Control chevron={false}>
            <Group className={classes.shiftTemplateRow} justify="space-between">
              <Text className={classes.shiftTemplateColumnCell} fw={600}>
                Navn
              </Text>
              <Text className={classes.shiftTemplateColumnCell} fw={600}>
                Dag
              </Text>
              <Text className={classes.shiftTemplateColumnCell} fw={600}>
                Lokale
              </Text>
              <Text className={classes.shiftTemplateColumnCell} fw={600}>
                Start
              </Text>
              <Text className={classes.shiftTemplateColumnCell} fw={600}>
                Slutt
              </Text>
            </Group>
          </Accordion.Control>
        </Accordion.Item>
        {accordionItems}
      </Accordion>
    </Paper>
  )
}

const shiftTemplateAccordionStyles = createStyles({
  shiftTemplateRow: {
    '& > :nth-of-type(3)': {
      textAlign: 'right',
    },
  },
  shiftTemplateColumnCell: {
    width: '120px',
    textAlign: 'left',
  },
})
